import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import ErrorPage from "@/pages/errorPage";
import RouteGuard from "@/components/security/routeGuard";
import { Login } from "@/pages/login";
import ApplicationMain from "@/pages/main";
import ModulePage from "@/pages/main/module";
import ModuleMerge from "@/pages/merge";
import ModuleBuilderPage from "@/pages/moduleBuilder";
import ModuleBuilder from "@/pages/moduleBuilder/builder";
import ModuleImport from "@/pages/import";
import AdministrationPage from "@/pages/administration/administration";
import Locale from "@/pages/administration/locale";
import Upgrade from "@/pages/administration/upgrade";
import ConfiguratorPage from "@/pages/configurator/configurator";
import EditView from "@/pages/configurator/editView";
import AclRolesEditView from "@/pages/aclRoles/editView";
import Repair from "@/pages/administration/repair";
import PasswordManager from "@/pages/administration/passwordManager";
import RepairXSS from "@/pages/administration/repairXSS";
import RepairSeedUsers from "@/pages/administration/repairSeedUsers";
import SecurityGroupPage from "@/pages/securityGroups/securityGroups";
import Config from "@/pages/securityGroups/config";
import AclRolesDetailView from "@/pages/aclRoles/detailView";
import { ThemeSettings } from "@/pages/administration/themeSettings";
import SearchPage from "@/pages/main/search";
import EmailSettings from "@/pages/administration/emailSettings";
import UpgradeWizard from "@/pages/administration/upgradeWizard";
import CampaignConfig from "@/pages/emailman/campaignconfig";
import { Backgroundimgsettings } from "@/pages/administration/backgroundimgsettings";
import AdminHome from "@/pages/administration/adminHome";
import Connector from "@/pages/administration/connector";
import ResetPasswordPage from "@/pages/password/changenewPassword";
import PasswordSettingPage from "@/pages/password/passwordSettingPage";
/**
 * Liste des routes pour la navigation
 */
var routes = [
    {
        path: "/",
        element: _jsx(RouteGuard, {}),
        errorElement: _jsx(ErrorPage, { code: "404" }),
        title: "",
        children: [
            {
                path: "",
                element: _jsx(ApplicationMain, {}),
                children: [
                    {
                        path: "",
                        element: _jsx(ModulePage, {}),
                    },
                    {
                        path: "/modules/:module",
                        element: _jsx(ModulePage, {}),
                    },
                    {
                        path: "/modules/:module/:action",
                        element: _jsx(ModulePage, {}),
                    },
                    {
                        path: "/modules/:module/:action/:record",
                        element: _jsx(ModulePage, {}),
                    },
                    {
                        path: "/modules/:module/:action/:record/:type",
                        element: _jsx(SearchPage, {}),
                    },
                ],
            },
            {
                path: "modules/ModuleBuilder",
                element: _jsx(ModuleBuilderPage, {}),
                children: [
                    {
                        path: "/modules/ModuleBuilder",
                        element: _jsx(ModuleBuilder, {}),
                    },
                    {
                        path: "/modules/ModuleBuilder/:type",
                        element: _jsx(ModuleBuilder, {}),
                    },
                    {
                        path: "/modules/ModuleBuilder/:type/packages",
                        element: _jsx(ModuleBuilder, {}),
                    },
                    {
                        path: "/modules/ModuleBuilder/:type/packages/:packagesName",
                        element: _jsx(ModuleBuilder, {}),
                    },
                    {
                        path: "/modules/ModuleBuilder/:type/packages/:packagesName/:moduleName",
                        element: _jsx(ModuleBuilder, {}),
                    },
                    {
                        path: "/modules/ModuleBuilder/:type/packages/:packagesName/:moduleName/:menu",
                        element: _jsx(ModuleBuilder, {}),
                    },
                    {
                        path: "/modules/ModuleBuilder/:type/packages/:packagesName/:moduleName/:menu/:fieldName",
                        element: _jsx(ModuleBuilder, {}),
                    },
                    {
                        path: "/modules/ModuleBuilder/:type/packages/:packagesName/:moduleName/:menu/:fieldName/:actionWidget",
                        element: _jsx(ModuleBuilder, {}),
                    },
                    /** dropdown list */
                    {
                        path: "/modules/ModuleBuilder/:type/lists",
                        element: _jsx(ModuleBuilder, {}),
                    },
                    {
                        path: "/modules/ModuleBuilder/:type/lists/:dropdownName",
                        element: _jsx(ModuleBuilder, {}),
                    },
                    {
                        path: "/modules/ModuleBuilder/:type/lists/:dropdownName/:packagesName/:moduleName/:menu/:fieldName",
                        element: _jsx(ModuleBuilder, {}),
                    },
                ],
            },
            {
                path: "/modules/Administration",
                element: _jsx(AdministrationPage, {}),
                children: [
                    {
                        path: "",
                        element: _jsx(AdminHome, {}),
                    },
                    {
                        path: "Locale",
                        element: _jsx(Locale, {}),
                    },
                    {
                        path: "Upgrade",
                        element: _jsx(Upgrade, {}),
                    },
                    {
                        path: "ThemeSettings",
                        element: _jsx(ThemeSettings, {}),
                    },
                    {
                        path: "Connector",
                        element: _jsx(Connector, {}),
                    },
                    {
                        path: "backgroundimgsettings",
                        element: _jsx(Backgroundimgsettings, {}),
                    },
                    {
                        path: "EmailSettings",
                        element: _jsx(EmailSettings, {}),
                    },
                    {
                        path: "PasswordManager",
                        element: _jsx(PasswordManager, {}),
                    },
                    {
                        path: "Emailman/campaignconfig",
                        element: _jsx(CampaignConfig, {}),
                    },
                    {
                        path: "Upgrade/repair/:action",
                        element: _jsx(Repair, {}),
                    },
                    {
                        path: "Upgrade/repair/:action/:type",
                        element: _jsx(Repair, {}),
                    },
                    {
                        path: "Upgrade/repairXSS",
                        element: _jsx(RepairXSS, {}),
                    },
                    {
                        path: "Upgrade/repairSeedUsers",
                        element: _jsx(RepairSeedUsers, {}),
                    },
                    {
                        path: "UpgradeWizard",
                        element: _jsx(UpgradeWizard, {}),
                    },
                ],
            },
            {
                path: "",
                element: _jsx(PasswordSettingPage, {}),
                children: [
                    {
                        path: "resetPassword/:guid",
                        element: _jsx(ResetPasswordPage, {}),
                    },
                ],
            },
            {
                path: "",
                element: _jsx(ConfiguratorPage, {}),
                children: [
                    {
                        path: "modules/ACLRoles/EditView",
                        element: _jsx(AclRolesEditView, {}),
                    },
                ],
            },
            {
                path: "",
                element: _jsx(ConfiguratorPage, {}),
                children: [
                    {
                        path: "modules/ACLRoles/DetailView/:recordId",
                        element: _jsx(AclRolesDetailView, {}),
                    },
                ],
            },
            {
                path: "",
                element: _jsx(ConfiguratorPage, {}),
                children: [
                    {
                        path: "modules/Configurator/EditView",
                        element: _jsx(EditView, {}),
                    },
                ],
            },
            /* {
              path: "",
              element: <InboundEmailPage />,
              children: [
                {
                  path: "modules/InboundEmail/EditView",
                  element: <InboundEmailEdit />,
                },
              ],
            },*/
            {
                path: "",
                element: _jsx(SecurityGroupPage, {}),
                children: [
                    {
                        path: "modules/SecurityGroups/config",
                        element: _jsx(Config, {}),
                    },
                ],
            },
            {
                path: "login",
                element: _jsx(Login, {}),
            },
            {
                path: "static",
                element: _jsx(_Fragment, { children: "Page statique" }),
            },
            {
                path: "modules/:module/Merge",
                element: _jsx(ModuleMerge, {}),
            },
            {
                path: "modules/Import/:step",
                element: _jsx(ModuleImport, {}),
            },
        ],
    },
];
export default routes;
